import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Message} from "semantic-ui-react"
import Responsive from "react-responsive"
import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class ContactMessage extends Component {

    state = {
        bausteinValue: "", 
        bausteinSeason: "",
        preferredBaustein: false
        }

    componentDidMount() {
        this.handleGetExtras()
    }

    handleGetExtras = () => {
    console.log("EXTRAS", shop.cart.data)
        if(shop.cart && shop.cart.data && shop.cart.data.extras && shop.cart.data.extras.bausteinValue){
            this.setState({bausteinValue: shop.cart.data.extras.bausteinValue})
            this.setState({bausteinSeason: shop.cart.data.extras.bausteinSeason})
            this.setState({preferredBaustein: shop.cart.data.extras.preferredBaustein})
        }
    }

	render() {
        const {bausteinValue, bausteinSeason, preferredBaustein} = this.state
        console.log("BAUSTEINVALUE", bausteinValue, "BAUSTEINSEASON", bausteinSeason, "NO PREFERRED BAUSTEIN", preferredBaustein)
		return (
            <Fragment>
                <Responsive minWidth={790} >
                <Message className="message" style={{width: "80%", borderRadius: "25px"}}>
                    <div>{translate( "Falls Sie Schwierigkeiten bei der Anmeldung haben und/oder weitere Fragen zum Shop, wenden Sie sich bitte an unsere Service-Hotline. Diese ist Montag - Donnerstag in der Zeit von 8:00 – 16:00 Uhr sowie Freitag von 8:00 – 13:00 Uhr unter der Telefonnummer 05641 95 337 gerne für Sie erreichbar.")}</div>
                </Message>
                {preferredBaustein && <Message className="ui negative message" style={{width: "80%", borderRadius: "25px"}}>
                    <div><Icon className="warning circle"></Icon>
                    {translate( "Der empfohlende Baustein ist für Sie bereits markiert, Sie können natürlich auch einen anderen Baustein wählen.")}</div>
                </Message>}
                </Responsive>
                <Responsive maxWidth={789} >
                <Message className="message" style={{width: "100%", borderRadius: "25px"}}>
                    <div>{translate( "Falls Sie Schwierigkeiten bei der Anmeldung haben und/oder weitere Fragen zum Shop, wenden Sie sich bitte an unsere Service-Hotline. Diese ist Montag - Donnerstag in der Zeit von 8:00 – 16:00 Uhr sowie Freitag von 8:00 – 13:00 Uhr unter der Telefonnummer 05641 95 337 gerne für Sie erreichbar.")}</div>
                </Message>
                {preferredBaustein && <Message className="ui negative message" style={{width: "100%", borderRadius: "25px"}}>
                    <div><Icon className="warning circle"></Icon>
                    {translate( "Der empfohlende Baustein ist für Sie bereits markiert, Sie können natürlich auch einen anderen Baustein wählen.")}</div>
                </Message>}
                </Responsive>
                </Fragment>
		)
	}
}





// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Messages/ContactMessage.js